import { useMemo } from 'react';

const useAppRoutes = ({ user, routeProviders = [], context = {} }) => {
  const routes = useMemo(() => {
    if (!user) return [];

    return routeProviders.reduce((acc, routeProvider) => {
      const providerRoutes = routeProvider(user, context);
      return [...acc, ...providerRoutes];
    }, []);
  }, [user, routeProviders, context]);

  return routes.filter((route) => !!route.show);
};

export default useAppRoutes;
